import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { Checkbox, DateString, NonNegativeMonetaryValue } from '../fields';

// Reduced-field row for the "Mortgage Insurance" disbursement bulk action. Unlike the generic
// escrow row, payee/recipient are not supplied — they are derived from the matched mortgage
// insurance escrow line item (matched by certificate/FHA case number).
export const RecordMortgageInsuranceDisbursementRow = z.object({
  loanId: LosId,
  certificateCaseNumber: z.string(),
  disbursementDate: DateString,
  disbursementTotal: NonNegativeMonetaryValue,
  updateNextPaymentAmount: Checkbox.optional(),
  note: z.string().optional(),
});
export type RecordMortgageInsuranceDisbursementRow = z.infer<typeof RecordMortgageInsuranceDisbursementRow>;

export const RECORD_MI_DISBURSEMENT_ROW_REQUIRED_FIELDS = Object.keys(
  RecordMortgageInsuranceDisbursementRow.shape,
).filter(
  (key) =>
    !RecordMortgageInsuranceDisbursementRow.shape[
      key as keyof typeof RecordMortgageInsuranceDisbursementRow.shape
    ].isOptional(),
);
